import { IProductButton, IProductChip, IProductInfo, ProductActionEnum } from "../services/product/productdetails.service";

export const productChips: IchipTypes = {
    activeSubscription: {
        state: 'success',
        text: 'Active Subscription',
        id: '',
        filling: 'filled',
        type: 'small'
    },
    cancledSubscription: {
        state: 'error',
        text: 'Subscription Cancelled',
        id: '',
        filling: 'filled',
        type: 'small'
    },
    cancellationRequest: {
        state: 'warning',
        text: 'Cancellation Scheduled',
        id: '',
        filling: 'filled',
        type: 'small'
    },
    trialStarted: {
        state: 'primary',
        text: 'Trial Started',
        id: '',
        filling: 'filled',
        type: 'small'
    },
    trialEnding: (remainingDays: number) => ({
        state: 'warning',
        text: `${remainingDays} Days of Trial Left`,
        id: '',
        filling: 'filled',
        type: 'small'
    } as IProductChip),
    trialNotStarted: {
        state: 'neutral',
        text: 'Trial Not Started',
        id: '',
        filling: 'filled',
        type: 'small'
    },
    trialEnded: {
        state: 'warning',
        text: 'Trial Ended',
        id: '',
        filling: 'filled',
        type: 'small'
    }
}
export const productButtons: IbuttonTypes = {
    startFreeTrial: {
        text: 'Start Free Trial',
        type: 'START_FREE_TRIAL'
    },
    goToProduct: {
        text: 'Go to Product',
        type: 'GO_TO_PRODUCT',
    },
    viewPricing: {
        text: 'View Pricing',
        type: 'VIEW_PRICING'
    },
    scheduleDemo: {
        text: 'Book Demo',
        type: 'SCHEDULE_DEMO'
    }
};

export const defaultDatonProduct: IProductInfo = {
    name: 'daton',
    id: 1,
    remainingDays: 0,
    button: productButtons.startFreeTrial,
    chip: productChips.trialNotStarted,
    status: 'NONE',
    isTrialEntryEmpty: true
}
export const defaultPulseProduct: IProductInfo = {
    name: 'insights',
    id: 2,
    remainingDays: 0,
    button: productButtons.scheduleDemo,
    chip: productChips.trialNotStarted,
    status: 'NONE',
    isTrialEntryEmpty: true
}
export const defaultIqProduct: IProductInfo = {
    name: 'iq',
    id: 3,
    remainingDays: 0,
    button: productButtons.scheduleDemo,
    chip: productChips.trialNotStarted,
    status: 'NONE',
    isTrialEntryEmpty: true
}

export const datonProductCardDetails: IProductCardDetails = {
    title: 'Daton',
    body: `Move your data from 150+ sources and transform into analytics-ready tables`,
    image: '../assets/datonCard.svg',
    documentationLink: 'https://help.sarasanalytics.com/en_US/daton-get-started/how-to-get-started-with-daton-setup'
}
export const pulseProductCardDetails: IProductCardDetails = {
    title: 'Daton Pulse',
    image: '../assets/pulseCard.svg',
    body: `Power Your Decisions with Advanced Analytics`,
    documentationLink: 'https://help.sarasanalytics.com/getting-started/product-walkthrough'
}
export const iqProductCardDetails: IProductCardDetails = {
    title: 'Saras iQ',
    image: '../assets/iq.svg',
    body: `AI-powered analytics platform that instantly answers your eCommerce data questions`,
    documentationLink: 'https://help.sarasanalytics.com/en_US/getting-started-saras-IQ/setting-up-your-iq-account'
}
interface IchipTypes {
    activeSubscription: IProductChip,
    cancledSubscription: IProductChip,
    cancellationRequest: IProductChip,
    trialStarted: IProductChip,
    trialEnding: Function,
    trialNotStarted: IProductChip,
    trialEnded: IProductChip,
}
interface IbuttonTypes {
    startFreeTrial: IProductButton,
    goToProduct: IProductButton,
    viewPricing: IProductButton,
    scheduleDemo: IProductButton
}
interface IProductCardDetails {
    title: string,
    image: string,
    body: string,
    documentationLink: string;
}